import { render, staticRenderFns } from "./TimeReport.vue?vue&type=template&id=45454014"
import script from "./TimeReport.vue?vue&type=script&lang=js"
export * from "./TimeReport.vue?vue&type=script&lang=js"
import style0 from "./TimeReport.vue?vue&type=style&index=0&id=45454014&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon});
